import File from './file';
import Doodad from './doodad';
import RandomItemSet from './randomitemset';
import RandomItem from './randomitem';
import TerrainDoodad from './terraindoodad';

export default {
  File,
  Doodad,
  RandomItemSet,
  RandomItem,
  TerrainDoodad,
};
